<div class="body">
  <div class="mt-2">

    <div class="float-left">
      <label class="escuro">Detalhes da fatura</label>
    </div>

    <div class="float-right">
      <label class="escuro">Vencimento</label><br>
      <span>{{fatura.dataVencimento}}</span>
    </div>

  </div>

  <div class="clearfix"></div>

  <div class="mt-2">
    <table class="table  ">
      <thead>
      <tr>
        <th class="escuro">Descrição</th>
        <th class="escuro" style="     width: 90px; ">
          <span class="float-right">Valor</span></th>
      </tr>
      </thead>
      <tbody *ngIf="!exibeLancamentosAgrupados">
      <tr *ngFor="let lacamento of fatura.lancamentos">
        <td>{{lacamento.descricao}}</td>
        <td >
          <span class="float-right">
              {{lacamento.total | currency: "BRL"}}
          </span>

        </td>
      </tr>
      </tbody>
      <tbody *ngIf="exibeLancamentosAgrupados">
      <ng-container *ngFor="let grupo of gruposLancamentos">
        <tr class="grupo-empresa-cabecalho" (click)="grupo.aberto = !grupo.aberto">
          <td>{{grupo.empresa?.nome}}</td>
          <td>
            <span class="float-right">{{grupo.total | currency: "BRL"}}</span>
          </td>
        </tr>
        <tr class="grupo-empresa-item" *ngFor="let lancamento of grupo.itens" [hidden]="!grupo.aberto">
          <td>{{lancamento.descricao}}</td>
          <td>
            <span class="float-right">
              {{lancamento.total | currency: "BRL"}}
            </span>
          </td>
        </tr>
      </ng-container>
      </tbody>
      <tfoot>
      <tr>
        <td colspan="2">
          <label class="float-right">
            Total:
            <span class="font-16 ml-2 escuro"> <b>{{fatura.total | currency: "BRL"}}</b></span>
          </label>
        </td>
      </tr>
       <tr *ngIf="fatura.paga">
         <td colspan="2">
           <label class="float-right">
              {{fatura.descricaoPagamento}}
                <span *ngIf="fatura.parcelas"> <b>parcelado em {{fatura.parcelas}}x</b></span>

           </label>
         </td>
       </tr>
      </tfoot>
    </table>
  </div>

</div>

<div class="linha-fundo"></div>
